export default __webpack_public_path__ + "static/media/coinRS.870ee3a2.png";